import { render } from "./SideBar.vue?vue&type=template&id=4646a77f&scoped=true&ts=true"
import script from "./SideBar.vue?vue&type=script&lang=ts"
export * from "./SideBar.vue?vue&type=script&lang=ts"

import "./SideBar.vue?vue&type=style&index=0&id=4646a77f&lang=scss&scoped=true"
import "./SideBar.vue?vue&type=style&index=1&id=4646a77f&lang=scss"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4646a77f"]])

export default __exports__